import Vue from 'vue';

export default {
  async get(filter) {
    return (await Vue.http.post('/api/hdraces/tickets/list', filter)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/hdraces.service.js